export function FamilySummarySkeleton() {
  return (
    <div className="space-y-6">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md p-6 animate-pulse"
        >
          {/* Member name skeleton */}
          <div className="h-6 bg-gray-200 rounded w-1/4 mb-4" />

          {/* Meal list skeleton */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
          </div>

          {/* Total skeleton */}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="h-4 bg-gray-200 rounded w-1/3" />
          </div>
        </div>
      ))}
    </div>
  );
}
